// This file is automatically generated by `generated_js` task. Any changes will be lost
/* tslint:disable */
export const GoCDVersion = {
  "version": "24.1.0",
  "buildNumber": "18867",
  "gitSha": "a60529cdf34a96de310bc05e2041f2ac23014707",
  "fullVersion": "24.1.0-18867",
  "formattedVersion": "24.1.0 (18867-a60529cdf34a96de310bc05e2041f2ac23014707)",
  "copyrightYear": "2024"
}


function stripLeadingPrefix(suffix: string, prefix: string) {
  if (suffix.startsWith(prefix)) {
      suffix = suffix.substring(1);
  }
  return suffix;
}

export function docsUrl(suffix: string = '') {
  return `https://docs.gocd.org/24.1.0/${stripLeadingPrefix(suffix, '/')}`
}

export function apiDocsUrl(suffix: string = '') {
  return `https://api.gocd.org/24.1.0/${stripLeadingPrefix(suffix, '#')}`
}
    
